module.exports = __webpack_public_path__ + "img/chip_1m.48151f44.png";